import * as actionTypes from './actionTypes';
import axiosInstance from '../../axios-instance';

export const policyCarrierSuccess = payload => {
  return {
    type: actionTypes.POLICY_CARRIERS_SUCCESS,
    payload: payload
  };
};

export const policyCarrierStart = () => {
  return {
    type: actionTypes.POLICY_CARRIERS_START
  };
};

export const policyCarrierFail = error => {
  return {
    type: actionTypes.POLICY_CARRIERS_FAIL,
    error: error
  };
};
export const getPolicyCarriersList = (getData, hideLoader) => {
  return dispatch => {
    if (!(hideLoader !== undefined && hideLoader === true)) {
      //dispatch(policyCarrierStart());
    }
    axiosInstance()
      .get('/carriers.json', { params: getData })
      .then(response => {
        dispatch(policyCarrierSuccess({ ...response.data, loaded: true }));
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(policyCarrierFail(err.response.data.message));
        } else {
          dispatch(policyCarrierFail('Problem with connection to API.'));
        }
      });
  };
};

export const createPolicyCarrier = (postData, history) => {
  return dispatch => {
    dispatch(policyCarrierStart());
    axiosInstance()
      .post('/carriers.json', postData)
      .then(response => {
        history.push('/carriers/' + response.data.id);
        dispatch(policyCarrierSuccess({ list: [], loaded: true }));
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(policyCarrierFail(err.response.data.message));
        } else {
          dispatch(policyCarrierFail('Problem with connection to API.'));
        }
      });
  };
};

export const editPolicyCarrier = (entityId, postData, callback) => {
  return dispatch => {
    dispatch(policyCarrierStart());
    axiosInstance()
      .put(`/carriers/${entityId}.json`, postData)
      .then(response => {
        dispatch(policyCarrierSuccess({ viewItem: response.data }));
        dispatch(policyCarrierSuccess({ list: [], loaded: true }));
        callback();
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(policyCarrierFail(err.response.data.message));
        } else {
          dispatch(policyCarrierFail('Problem with connection to API.'));
        }
      });
  };
};

export const getPolicyCarrier = entityId => {
  return dispatch => {
    //dispatch(loaderStart());
    axiosInstance()
      .get('/carriers/' + entityId + '.json')
      .then(response => {
        dispatch(policyCarrierSuccess({ viewItem: response.data }));
        //dispatch(loaderStop());
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(policyCarrierFail(err.response.data.message));
        } else {
          dispatch(policyCarrierFail('Problem with connection to API.'));
        }
        //dispatch(loaderStop());
      });
  };
};
